import { render, staticRenderFns } from "./ClcDashboardCustomer.vue?vue&type=template&id=37206b1a&"
import script from "./ClcDashboardCustomer.vue?vue&type=script&lang=js&"
export * from "./ClcDashboardCustomer.vue?vue&type=script&lang=js&"
import style0 from "./ClcDashboardCustomer.vue?vue&type=style&index=0&id=37206b1a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports